/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M24.05 0c-13.234 0-24 10.766-24 24s10.766 24 24 24 24-10.766 24-24-10.766-24-24-24zm0 42.891C13.627 42.891 5.159 34.423 5.159 24S13.627 5.109 24.05 5.109 42.941 13.577 42.941 24 34.473 42.891 24.05 42.891zm12.514-19.645h-10.8v-12.96c0-1.097-.891-1.989-1.988-1.989s-1.955.892-1.955 1.989v14.948a1.99 1.99 0 001.989 1.989h12.754c1.097 0 1.989-.892 1.989-1.989s-.892-1.988-1.989-1.988z"/>'
}
